import { useEffect, useState } from "react";

/**
 * v1.29.13 — Persist the user's chosen ledger sort direction (newest
 * first vs oldest first) across sessions using localStorage. Shared
 * between Admin Party Ledger (Reports.jsx) and the Customer portal
 * ledger (CustomerLedger.jsx) so a user's preference travels with them.
 *
 * Default: `{ by: "date", dir: "desc" }` — latest entry at the top.
 */
const STORAGE_KEY = "micm.ledger.sort.v2";

export default function useLedgerSortPref(defaultSort = { by: "date", dir: "desc" }) {
    const [sort, setSort] = useState(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw) {
                const parsed = JSON.parse(raw);
                if (parsed && parsed.by && parsed.dir) return parsed;
            }
        } catch {
            /* ignore malformed value */
        }
        return defaultSort;
    });
    useEffect(() => {
        try {
            if (sort?.by && sort?.dir) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(sort));
            }
        } catch {
            /* storage full or blocked — safe to swallow */
        }
    }, [sort]);
    return [sort, setSort];
}
